module.exports = __webpack_public_path__ + "img/Group4.e929d83f.svg";